import { pciRouteMapByURL } from '@shared/constants/routes.pci'
import { isOnServer } from '@shared/constants/util'

export const getIsPciRoutingRequired = ({ href }: { href: string }) => {
  if (isOnServer()) return true

  const isCurrentUrlPCISecured = pciRouteMapByURL.has(window.location.pathname)
  if (isCurrentUrlPCISecured) return true

  const targetPathname = href.split('?')[0] ?? ''
  return pciRouteMapByURL.has(targetPathname)
}
